import {
    List,
    Datagrid,
    TextField,
    useListContext,
    DatagridBody,
} from 'react-admin';
import {Box, Divider, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography} from '@mui/material';
import {useEffect, useState} from "react";
import CourierService from "../../services/courier/courierService.ts";
import {useTranslation} from 'react-i18next';
import {useParams} from "react-router-dom";


//TODO: move styles to a separate file if possible

const RiderTableActions = () => {
    const {t} = useTranslation();
    return (
        <Box
            sx={{
                paddingTop: 'var(--space-72)',
                paddingBottom: 'var(--space-32)',
                flex: 1,
                display: 'flex',
                alignItems: 'start',
                flexDirection: 'column',
                justifyContent: 'space-between',
            }}
        >
            <Typography variant="h5" sx={{
                paddingLeft: 'var(--space-24)',
                fontWeight: 700,
                fontSize: 'var(--text-xxl)',
            }}>
                {t('resources.performance')}
            </Typography>
            <Divider
                variant="middle"
                sx={{
                    width: '460px',
                    alignSelf: 'stretch',
                    my: 'var(--space-24)',
                    borderTopWidth: 1,
                    borderColor: 'var(--color-secondary)',
                }}
            />

            <Typography variant="h5" sx={{
                paddingLeft: 'var(--space-24)',
                fontWeight: 700,
                fontSize: 'var(--text-lg)',
            }}>
                Orders delivered
            </Typography>
        </Box>
    )
};

const RiderPerformanceDatagridBody = ({courierId, ...props}) => {
    const {data} = useListContext();
    const courierService = new CourierService();
    const [performance, setPerformance] = useState(null);
    useEffect(() => {
        const fetchPerformance = async () => {
            const response = await courierService.getCourierPerformance(courierId);
            console.log(JSON.stringify(response));
        };
        fetchPerformance();
    }, [courierId])

    console.log('data', data);

    const totalAmount = data
        ?.map(item => Number(item.orderAmount?.replace('€', '')))
        .reduce((sum, val) => sum + val, 0) || 0;

    const totalCashCollected =
        data
            ?.map(item =>
                item.cashCollected !== 'N/A'
                    ? Number(item.cashCollected?.replace('€', ''))
                    : 0
            )
            .reduce((sum, val) => sum + val, 0) || 0;

    const riderEarnings = data
        ?.map(item => Number(item.riderEarnings?.replace('€', '')))
        .reduce((sum, val) => sum + val, 0) || 0;

    return (
        <>
            <DatagridBody {...props} />

            <TableRow sx={{backgroundColor: '#fff'}}>
                <TableCell sx={{
                    fontWeight: 700,
                    textAlign: 'center',
                    borderBottom: 'none'
                }}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: 'fit-content',
                        textAlign: 'center',
                        fontSize: 'var(--text-xxs)'
                    }}>
                        <Box sx={{width: 'fit-content', textAlign: 'center'}}>Total orders delivered</Box>
                        <Box sx={{width: 'fit-content', mx: 'auto'}}>{data?.length}</Box>
                    </Box>
                </TableCell>

                <TableCell sx={{
                    fontWeight: 700,
                    textAlign: 'center',
                    borderBottom: 'none'
                }}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: 'fit-content',
                        textAlign: 'center',
                        fontSize: 'var(--text-xxs)'
                    }}>
                        <Box sx={{width: 'fit-content', textAlign: 'center'}}>Total amount from orders</Box>
                        <Box sx={{width: 'fit-content', mx: 'auto'}}>{totalAmount}€</Box>
                    </Box>
                </TableCell>

                <TableCell sx={{
                    fontWeight: 700,
                    textAlign: 'center',
                    borderBottom: 'none'
                }}/>

                <TableCell sx={{
                    fontWeight: 700,
                    textAlign: 'center',
                    borderBottom: 'none'
                }}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: 'fit-content',
                        textAlign: 'center',
                        fontSize: 'var(--text-xxs)'
                    }}>
                        <Box sx={{width: 'fit-content', textAlign: 'center'}}>Total cash collected</Box>
                        <Box sx={{width: 'fit-content', mx: 'auto'}}>
                            {totalCashCollected}€
                        </Box>
                    </Box>
                </TableCell>

                <TableCell sx={{
                    fontWeight: 700,
                    textAlign: 'center',
                    borderBottom: 'none'
                }}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: 'fit-content',
                        textAlign: 'center',
                        fontSize: 'var(--text-xxs)'
                    }}>
                        <Box sx={{width: 'fit-content', textAlign: 'center'}}>Total earnings</Box>
                        <Box sx={{width: 'fit-content', mx: 'auto'}}>
                            {riderEarnings}€
                        </Box>
                    </Box>
                </TableCell>

                <TableCell sx={{
                    fontWeight: 700,
                    textAlign: 'center',
                    borderBottom: 'none'
                }}/>
            </TableRow>
        </>
    );
};

export const RiderPerformanceTable = () => {
    const {t} = useTranslation();
    const {id} = useParams();
    const courierService = new CourierService();
    const [performance, setPerformance] = useState<any[]>([]);

    useEffect(() => {
        const fetchPerformance = async () => {
            const response = await courierService.getCourierPerformance(Number(id));
            setPerformance(response);
        };
        fetchPerformance();
    }, [id]);

    const totalAmount = performance
        .reduce((sum, item) => sum + (item.orderAmount || 0), 0);

    return (
        <>
            <RiderTableActions/>
            <Box sx={{px: 4}}>
                <Box sx={{
                    border: '1px solid var(--color-secondary)',
                    borderRadius: 'var(--radius-6)',
                }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell
                                    sx={{fontWeight: 700}}>{t('riderPerformance.columns.orderAmount')}</TableCell>
                                <TableCell
                                    sx={{fontWeight: 700}}>{t('riderPerformance.columns.paymentMethod')}</TableCell>
                                <TableCell
                                    sx={{fontWeight: 700}}>{t('riderPerformance.columns.dateOfOrder')}</TableCell>
                                <TableCell
                                    sx={{fontWeight: 700}}>{t('riderPerformance.columns.orderNumber')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {performance.map((row) => (
                                <TableRow key={row.orderNumber}>
                                    <TableCell>{row.orderAmount}€</TableCell>
                                    <TableCell>{row.paymentMethod}</TableCell>
                                    <TableCell> {new Date(row.dateOfOrder + "Z").toLocaleString()}</TableCell>
                                    <TableCell>{row.orderNumber}</TableCell>
                                </TableRow>
                            ))}
                            <TableRow sx={{backgroundColor: '#fff'}}>
                                <TableCell sx={{fontWeight: 700}}>
                                    Total: {performance.length} orders
                                </TableCell>
                                <TableCell sx={{fontWeight: 700}}>
                                    {totalAmount.toFixed(2)}€
                                </TableCell>
                                <TableCell colSpan={3}/>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Box>
            </Box>
        </>
    );
};
